import { useState } from 'react';
import type { ReactNode } from 'react';
import styles from './Sidebar.module.css';

export default function Sidebar({ children }: { children?: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed}`}>
      <button
        className={styles.toggleButton}
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? 'Seitenleiste schließen' : 'Seitenleiste öffnen'}
      >
        {isOpen ? '←' : '→'}
      </button>
      <div className={styles.sidebarContent}>
        {children}
      </div>
    </div>
  );
}
